import { Injectable } from '@angular/core';
import { Router, NavigationStart } from '@angular/router';
import { Observable } from 'rxjs';
import { Subject } from 'rxjs/Subject';

import { Toaster, ToasterType } from '../directives/toaster/toaster';

@Injectable()
export class ToasterService {
    private subject = new Subject<Toaster>();
    private keepAfterRouteChange = false;

    constructor(private router: Router) {
        // clear toaster messages on route change unless 'keepAfterRouteChange' flag is true
        router.events.subscribe((event) => {
            if (event instanceof NavigationStart) {
                if (this.keepAfterRouteChange) {
                    // only keep for a single route change
                    this.keepAfterRouteChange = false;
                } else {
                    // clear toaster messages
                    this.clear();
                }
            }
        });
    }

    public getToaster(): Observable<any> {
        return this.subject.asObservable();
    }

    public success(title: string, message: string, keepAfterRouteChange = false, toastLife: number = 2000): void {
        this.toaster(ToasterType.Success, title, message, keepAfterRouteChange, toastLife);
    }

    public error(title: string, message: string, keepAfterRouteChange = false, toastLife: number = 2000): void {
        this.toaster(ToasterType.Error, title, message, keepAfterRouteChange, toastLife);
    }

    public info(title: string, message: string, keepAfterRouteChange = false, toastLife: number = 2000): void {
        this.toaster(ToasterType.Info, title, message, keepAfterRouteChange, toastLife);
    }

    public warn(title: string, message: string, keepAfterRouteChange = false, toastLife: number = 2000): void {
        this.toaster(ToasterType.Warning, title, message, keepAfterRouteChange, toastLife);
    }

    public toaster(type: ToasterType, title: string, message: string, keepAfterRouteChange = false, toastLife: number = 2000): void {
        this.keepAfterRouteChange = keepAfterRouteChange;
        this.subject.next(<Toaster> { type, title, message, toastLife });
    }

    public clear(): void {
        // clear toasters
        this.subject.next();
    }
}
